import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import {
  TPrototypePageDto,
  TPrototypePartialDto,
} from '@app-velocity/av-api-v2';

import { useReviewEvents } from '@app-velocity/modules/scenarios';

import { useHeatMap } from '../useHeatMap';

export const useCreateReviewHeatMap = (
  reviewId: string,
  prototypeId: string,
  workspaceId: string,
  scenarioPages: TPrototypePageDto[],
  scenarioPartials: TPrototypePartialDto[]
) => {
  const { fetchEvents, data } = useReviewEvents(
    reviewId,
    workspaceId,
    prototypeId
  );
  const { generate, clear } = useHeatMap(scenarioPages, scenarioPartials);

  const queryClient = useQueryClient();

  const generateHeatMap = () => {
    fetchEvents();
  };

  useEffect(() => {
    if (!data || data.length === 0) return;

    generate(data);

    queryClient.resetQueries({
      queryKey: ['scenario-review-events', workspaceId, prototypeId, reviewId],
    });
  }, [data]);

  return { generateHeatMap, clearHeatMap: clear };
};
